import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
	formControl:{
		position: 'relative',
		minWidth: prop => prop?.width ? prop.width : '25%',
		marginTop: prop => prop?.marginTop ? prop.marginTop : '2%',
		paddingRight: theme.spacing(2),
		'@media (max-width:1200px)':{
			width: '33%'
	},
	'@media (max-width:992px)':{
			width: '50%',
			marginTop: prop => prop?.marginTop ? prop.marginTop : '2.5%',
	},
	'@media (max-width:768px)':{
			width: '100%',
			marginTop: prop => prop?.marginTop ? prop.marginTop : '3.5%',
	},
	},
	helperText: {
		position: 'absolute',
		left: theme.spacing(2),
		top: '100%',
		marginTop: theme.spacing(0.5),
		marginLeft: 0,
		minHeight: theme.spacing(2),
	},
}));
